import ActionTypes from "../../../../../constants/ActionTypes";
import { IRecentlyViewedProductsState } from "./types";

const initialRecentlyViewedProductsState: IRecentlyViewedProductsState = {
  products: [],
};

const recentlyViewedProductsReducer = (
  state = initialRecentlyViewedProductsState,
  action: any,
): IRecentlyViewedProductsState => {
  switch (action.type) {
  case ActionTypes.PRODUCT.SET_RECENTLY_VIEWED:
    return {
      ...state,
      products: action.payload.products
    };
  }
  return state;
};

export default recentlyViewedProductsReducer;
